import initTemplate from './components/Template';
import initUiBase from './components/UiBase';
import initLastChanceModule from './components/UiBase/LastChanceModule';

import initLazyLoadBg from './globalListeners/lazyLoadBg';

import initHomepageV3 from './components/Homepage_v3';

$(function () {
  initLazyLoadBg();

  initTemplate();
  initUiBase();
  initLastChanceModule();

  initHomepageV3();
});
